import { render, staticRenderFns } from "./institutionAutocomplete.vue?vue&type=template&id=2ccd60f1"
import script from "./institutionAutocomplete.vue?vue&type=script&lang=ts"
export * from "./institutionAutocomplete.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports